import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question7.css";
import AI from "./images/ai.png";

const Question7 = ({ onAnswer, userResponse }) => {
  const question = {
    title:
      "How valuable would it be for you to have a step-by-step framework for writing your entire research in record time, with AI tools to guide you along?",
    questionImage: AI,
    options: [
      { label: "Extremely Valuable", percentage: 100 },
      { label: "Very Valuable", percentage: 75 },
      { label: "Somewhat Valuable", percentage: 50 },
      { label: "Not Valuable", percentage: 25 },
    ],
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }

    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question7-container"
        initial={{ opacity: 0, x: "20%" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        {question.questionImage && (
          <motion.img
            className="question7-img"
            src={question.questionImage}
            alt="Question"
            initial={{ opacity: 0, x: "-50vw" }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          />
        )}

        <motion.h2
          className="question7-head"
          initial={{ opacity: 0, x: "-50%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, y: "-50%" }}
          transition={{ duration: 0.8 }}
        >
          {question.title}{" "}
        </motion.h2>

        <motion.div
          className="option7-container"
          initial={{ opacity: 0, x: "20%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "10%" }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          {question.options.map((option, index) => {
            const isChecked = userResponse[question.title] === option.label;
            const color = getColor(option.percentage);

            return (
              <motion.label
                key={index}
                className={`radio7-option ${isChecked ? "checked" : ""}`}
                htmlFor={`option-${index}`}
                style={{ "--option-color": color }}
                initial={{ opacity: 0, x: "20%" }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: "10%" }}
                transition={{
                  duration: 0.5,
                  delay: 0.2 + index * 0.2,
                }}
              >
                <input
                  type="radio"
                  id={`option-${index}`}
                  name={`question-${question.title}`}
                  value={option.label}
                  checked={isChecked}
                  onChange={() => onAnswer(question.title, option.label)}
                />
                <span className="radio7-label">{option.label}</span>
              </motion.label>
            );
          })}
        </motion.div>

        <motion.button
          type="submit"
          initial={{ opacity: 0, x: "20%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, y: "10%" }}
          transition={{ duration: 0.8, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]}
        >
          Next Question
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

const getColor = (percentage) => {
  if (percentage === 100) {
    return "rgb(0, 179, 0)";
  } else if (percentage === 75) {
    return "rgb(209, 209, 0)";
  } else if (percentage === 50) {
    return "orange";
  } else if (percentage === 25) {
    return "red";
  }
  return "transparent";
};

export default Question7;
